module.exports = __webpack_public_path__ + "img/TrashButton.65a8156d.svg";